import { TOOLBAR_BUTTON } from '@common/enums';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ToolbarCanvasState {
    selectedToolbarButton?: TOOLBAR_BUTTON;
    isManualZoom: boolean;
}

const initialState: ToolbarCanvasState = {
    selectedToolbarButton: undefined,
    isManualZoom: false,
};

const toolbarCanvasSlice = createSlice({
    name: 'toolbarCanvas',
    initialState,
    reducers: {
        resetSelectedToolbarButton: (state) => {
            state.selectedToolbarButton = undefined;
        },
        updateManualZoom: (state, action: PayloadAction<boolean>) => {
            state.isManualZoom = action.payload;
        },
        updateSelectedToolbarButton: (state, action: PayloadAction<TOOLBAR_BUTTON>) => {
            state.selectedToolbarButton = action.payload;
            if (action.payload === TOOLBAR_BUTTON.ZOOM_IN || action.payload === TOOLBAR_BUTTON.ZOOM_OUT) {
                toolbarCanvasSlice.caseReducers.updateManualZoom(state, { type: 'updateManualZoom', payload: true });
            } else if (action.payload === TOOLBAR_BUTTON.ZOOM_TO_FIT) {
                toolbarCanvasSlice.caseReducers.updateManualZoom(state, { type: 'updateManualZoom', payload: false });
            }
        },
    },
});

export const { resetSelectedToolbarButton, updateSelectedToolbarButton } = toolbarCanvasSlice.actions;

export default toolbarCanvasSlice.reducer;

export const selectSelectedToolbarButton = ({ toolbarCanvas }: RootState): TOOLBAR_BUTTON | undefined =>
    toolbarCanvas.selectedToolbarButton;

export const selectIsManualZoom = ({ toolbarCanvas }: RootState): boolean => toolbarCanvas.isManualZoom;
